import { createContext, useState } from 'react'
import type { FC, ReactNode } from 'react'

export enum MODALS {
  // COOKIES = 'modal_cookies',
  MENU = 'modal_menu',
  NEW_PROJECT = 'modal_new_project',
  CREATE_ALBUM = 'modal_create_album',
  NUMBER_IMAGES = 'modal_number_images',
  AUTH= 'modal_auth',
  // NEWSLETTER= 'modal_newsletter',
  ZOOM='modal_zoom',
  DETAIL='modal_detail',
  DELETE= 'modal_delete',
  SINCE_2023='modal_since_2023',
  // VIDEO='modal_video'
}

export interface iDefaultModal { isActive: boolean, payload?: any }

// interface iModalAuthPayload {
//   payload: {
//     level: string
//   }
// }

type TypeModalException = {
  // [MODALS.AUTH]: iModalAuthPayload
}

// Utility to merge two Definitions: B object properties shadowing -> A object properties
type $Merge<TA, TB> = Omit<TA, keyof TB> & TB;
// Getting the Base+Extended type of an Modal
type TypeModalById<A extends MODALS> = A extends keyof TypeModalException ? $Merge<iDefaultModal, TypeModalException[A]> : iDefaultModal


type TypeModals = {
  [key in MODALS]?: TypeModalById<key>
}
type TypeModalsState = {
  modals: TypeModals,
  setModal: (modal: { [key: string]: iDefaultModal } | ((prev: TypeModals) => TypeModals)) => void,
  someModalIsActive: boolean
}

const initialModalsState: TypeModalsState = {
  modals: {},
  setModal: () => {},
  someModalIsActive: false
  //someModalIsActive: boolean at least one modal is Active ?
}

interface iModalsProviderProps {
  children: ReactNode
}

export const ModalsContext = createContext<TypeModalsState | null>(initialModalsState)

export const ModalsProvider:FC<iModalsProviderProps> = ({ children }) => {
  const [modals, setModals] = useState<TypeModals>({})
  const [someModalIsActive, setSomeModalIsActive] = useState(false)

  const setModal = (modal) => {
    setModals(prevModals => ({...prevModals, ...modal }))
    let someActive = false
    if (modal.isActive) someActive = true
    else {
      for (const [, m] of Object.entries(modals)) {
        if (m.isActive) {
          someActive = true
          break
        }
      }
    }

    setSomeModalIsActive(someActive)
  }



  return (<ModalsContext.Provider value={{ modals, setModal, someModalIsActive }}>
    {children}
  </ModalsContext.Provider>)
}
